define('responsive-gameday/views/Monitor/ViewModels/distributors/PregameViewDistributor',['require','exports','module','jquery-when-always/jquery-when-always','GameDayCore','../../Events/ViewModelUpdateEvents','../../Events/SceneStateEvents','extant/extant','Responsive/util/object','Responsive/util/array','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/util/DateConsts','responsive-gameday/utils/ui-log','message-service/message-service','gameday-index-enums/enums/baseball/GameStates','GameDayCore','moment','GameDayCore/GDModel/enums/datasources/Datasources','gameday-index-url-hasher/UrlHasher','gameday-business-rules/gameday-business-rules','gameday-language/translator'],function(require,exports,module) {
	var $ = require( "jquery-when-always/jquery-when-always" ),
		GDC = require("GameDayCore"),
		UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
		SceneStates = require("../../Events/SceneStateEvents"),
		exists = require("extant/extant"),
		ReObject = require("Responsive/util/object"),
        ReArray = require( 'Responsive/util/array' ),
		resourcePath = require("gameday-resource-path/gameday-resource-path"),
		dateConsts = require( 'GameDayCore/GDModel/enums/util/DateConsts' ),
        uilog = require( 'responsive-gameday/utils/ui-log' ),
		MessageService = require("message-service/message-service"),
		GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
		GameDayCore = require( 'GameDayCore' ),
		Moment = require("moment"),
		Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
		UrlHasher = require( "gameday-index-url-hasher/UrlHasher" ),
		rules = require("gameday-business-rules/gameday-business-rules"),
		GamedayRules = rules.getInstance(),
		gamedayLanguage = require( "gameday-language/translator");

	var gameData = {};
	
	function buildSendData(){
		gameData = GDC.getGameData();
		var that = this,
			rNotValidTeamCode=/^(tbd|nl|al|nhs|ahs|awc|nwc|als|nls|alc|nlc|adt|ndt|ndh|adh|zza|zzn)/,
			pitcherStatsType = "pitcher",
			days = dateConsts.days,
			months = dateConsts.months,
			gid = GDC.getCurrent().gid,
			start_date = new Date(gid.year, gid.month, gid.day),
			gamecenter = gameData.gamecenter || {},
			probables = { 
				home: gamecenter.home_probables || {},
				away: gamecenter.away_probables || {}
			},
			ticketsRequest = $.Deferred(),
			ticketUrl = "",
			linescore = gameData.linescore || {},
			season = linescore.id.substr(0,4),
			localGameTime = linescore.time_date,
			isTeamKnown = !rNotValidTeamCode.test(linescore.home_code.toLowerCase()),
			isPostponed = linescore && linescore.status === 'Postponed',
			isDelayed 	= linescore && linescore.status === 'Delayed Start',
			isCancelled = linescore && linescore.status === 'Cancelled',
			isTBD       =  (linescore.time_date.indexOf('3:33') > -1) ? true : false,				
			currentDate = new Date(),
			dataPack = self.dataPack || {
				pregame: {
					away: {},
					home: {}
				}
			},
			/**
			 * For first round and play off games, if the series number is less than 3,
			 * use regular season stats.
			 */
			seriesNum = ~~(linescore && (linescore.series_num)),
			game_type,
			sport_code = linescore.home_sport_code;

		switch(linescore.game_type){
			case "F":
			case "A":
				game_type = 'R';
			break;
			default:
				game_type = linescore.game_type;
			;
		}

		// Only using the tickets datasource for MiLB webviews.. MLB ticket links do not use this datasource
		if(sport_code !== "mlb") {
			MessageService.one.call(that, GDC.requestGameData(Datasources.TICKETS, {
				team_id: linescore.home_team_id,
				home_team_id: linescore.home_team_id,
				year: season
			}),function(payload){
				if(payload && 
					payload.ticketLinks && 
					payload.ticketLinks.ticketedEvents) {
						if(payload.ticketLinks.ticketedEvents instanceof Array) {
							payload.ticketLinks.ticketedEvents.forEach(function(game){
								if(game.game_id === linescore.gdid) {
									ticketUrl = game.ticket_link.tlink;
								}
							});
						} else {
							if(payload.ticketLinks.ticketedEvents.game_id === linescore.gdid) {
								ticketUrl = payload.ticketLinks.ticketedEvents.ticket_link.tlink;
							}
						}
					}
				
				ticketsRequest.resolve(payload);
			});
		} else {
			ticketsRequest.resolve({});
		}

		ticketsRequest.always(function (ticketsRequest) {

			var pitcherHomeSeason = probables && probables.home && probables.home.player_id,
				pitcherAwaySeason = probables && probables.away && probables.away.player_id,
				playerHeaderDefault = resourcePath.get('playerHeaderDefault'),
				dataPack = {
					pregame : {
						playerLink: '/team/player.jsp?player_id=',
						playerHeaderDefault : playerHeaderDefault,
						game : {
							blurb : gamecenter.league_articles && gamecenter.league_articles.preview && gamecenter.league_articles.preview.blurb,
							headline : gamecenter.league_articles && gamecenter.league_articles.preview && gamecenter.league_articles.preview.headline,
							image : gamecenter.photos && gamecenter.photos.ipad && 'http://mlb.com' + gamecenter.photos.ipad.url,
							statusClass : linescore.status === 'Postponed' && "postponed" || '',
							dateTime : Moment(localGameTime).format("dddd, MMMM DD, YYYY") || 'Time TBD',
							time: (isTBD) ? ((linescore.time === 'Gm 2') ? linescore.time : "TBD") : (Moment(localGameTime).format("h:mm") + " " + linescore.ampm),							
							time_zone: linescore.time === 'Gm 2' ? "" : linescore.time_zone,
							location : gameData.linescore.venue,
							park : linescore.game_pk,
							ticketsLink: sport_code == "mlb" ? (linescore.game_type == 'A' ? "http://mlb.mlb.com/mlb/events/all_star/y"+gid.year+"/all_star_tickets.jsp" : "/ticketing/singlegame.jsp?c_id=" + linescore.home_file_code + "#game=" + linescore.game_pk) : ticketUrl ? ticketUrl : "http://m.milb.com/" + linescore.home_file_code + "/ballpark/",
							url : gamecenter.league_articles && gamecenter.league_articles.preview && gamecenter.league_articles.preview.url && gamecenter.league_articles.preview.url.cid ? '//m.mlb.com/news/article/' + gamecenter.league_articles.preview.url.cid + '?game_pk=' + linescore.game_pk : undefined,
							jspath : gamecenter.league_articles && gamecenter.league_articles.preview && gamecenter.league_articles.preview.url ? '/js/' + gamecenter.id + '/recap/' : '',
							// If game type is "spring training", refer to the spring training rule to determine whether or not we hide / show the statcast tab
							hideStatcastTab: (game_type === "S" && GamedayRules.options.hideStatcastTabSpringTraining) ? true : false
						},
						away : {
							isActive : false,
							label : 'away',
							blurb : probables && probables.away && probables.away.report,
							channels : (typeof gamecenter.away_tv === 'object' ? undefined : gamecenter.away_tv) || undefined,
							team_id : linescore.away_team_id,
							sport_code : 'sport-'+linescore.away_sport_code.toLowerCase(),
							headline : gamecenter.away_articles && gamecenter.away_articles.previews && gamecenter.away_articles.previews.headline,
							name : linescore.away_team_name,
							display_name : sport_code == "mlb" ? linescore.away_team_name : linescore.away_team_city,
							file_code : gameData.linescore.away_file_code,
							upperCode: gameData.linescore.away_file_code.toUpperCase(),
							logo : resourcePath.get('teamLogoLarge',{code : linescore.away_code, file_code : linescore.away_file_code, sport_code : linescore.away_sport_code}),
							logoDefault : resourcePath.get('teamLogoLargeGeneric',{code : linescore.away_code, file_code : linescore.away_file_code, sport_code : linescore.away_sport_code}),
							pitcher : !isPostponed && probables && probables.away.lastName && typeof probables.away.lastName === 'string' ? {
								era : pitcherAwaySeason && pitcherAwaySeason.era|| probables.away.era,
								so: probables.away.so,
								full_name :typeof probables.away.lastName === 'string' ? probables.away.useName + ' ' + probables.away.lastName : 'TBD',
								full_name_with_comma: typeof probables.away.lastName === 'string' ? probables.away.useName + ' ' + probables.away.lastName + ',' : 'TBD',
								pid : probables.away.player_id,
								report: probables.away.report,
								last_name : probables.away.lastName,
								playerHeader : probables && probables.away.player_id ? resourcePath.get('playerAltHeader',{pid:probables.away.player_id, tid : linescore.away_file_code}) : resourcePath.get('playerHeaderDefault'),
								number : typeof probables.away.number === 'string' ? '#' + probables.away.number : '',
								arm : probables.away.throwinghand ? probables.away.throwinghand : "",
								losses : pitcherAwaySeason && pitcherAwaySeason.l || probables.away.losses,
								verified : true,
								wins : pitcherAwaySeason && pitcherAwaySeason.w || probables.away.wins,
								playerStatsLink : resourcePath.get('externalPlayerCardLink',{pid : probables.away.player_id})
							} : {
								era : '',
								full_name : 'TBD',
								full_name_with_comma : 'TBD',
								pid : '',
								last_name : 'TBD',
								playerHeader : playerHeaderDefault,
								number : '',
								arm : '',
								losses : '',
								tbd : true,
								verified : false,
								wins : ''
							},
							radio : (typeof gamecenter.away_radio === 'string' ? gamecenter.away_radio : null) || null,
							record : linescore.away_win + '-' + linescore.away_loss,
							shortname : linescore.away_name_abbrev,
							vs : linescore.home_name_abbrev
						},

						home : {
							isActive : true,
							label : 'home',
							blurb : probables && probables.home.report,
							channels : (typeof gamecenter.home_tv === 'object' ? '' : gamecenter.home_tv) || undefined,
							headline : gamecenter.home_articles && gamecenter.home_articles.previews && gamecenter.home_articles.previews.headline,
							sport_code : 'sport-'+linescore.home_sport_code.toLowerCase(),
							team_id : linescore.home_team_id,
							name : linescore.home_team_name,
							display_name : sport_code == "mlb" ? linescore.home_team_name : linescore.home_team_city,
							file_code : gameData.linescore.home_file_code,
							upperCode: gameData.linescore.home_file_code.toUpperCase(),
							logo : resourcePath.get('teamLogoLarge',{code : linescore.home_code, file_code : linescore.home_file_code, sport_code : linescore.home_sport_code}),
							logoDefault : resourcePath.get('teamLogoLargeGeneric',{code : linescore.home_code, file_code : linescore.home_file_code, sport_code : linescore.home_sport_code}),							
							pitcher : !isPostponed && probables && probables.home.lastName && typeof probables.home.lastName === 'string' ? {
								era : pitcherHomeSeason && pitcherHomeSeason.era || probables.home.era,
								so: probables.home.so,
								full_name : probables.home.useName + ' ' + probables.home.lastName,
								full_name_with_comma : probables.home.useName + ' ' + probables.home.lastName + ',',
								pid : probables.home.player_id,
								report: probables.home.report,
								last_name : probables.home.lastName,
								playerHeader : probables && probables.away.player_id ? resourcePath.get('playerHeader',{pid:probables.home.player_id,tid : linescore.home_file_code}) : resourcePath.get('playerHeaderDefault'),
								number : typeof probables.home.number === 'string' ? '#' + probables.home.number : '',
								arm : probables.home.throwinghand ? probables.home.throwinghand : "",
								losses : pitcherHomeSeason && pitcherHomeSeason.l || probables.home.losses,
								verified : true,
								wins : pitcherHomeSeason && pitcherHomeSeason.w || probables.home.wins,
								playerStatsLink : resourcePath.get('externalPlayerCardLink',{pid : probables.home.player_id})
							} : {
								era : '',
								full_name : 'TBD',
								full_name_with_comma : 'TBD',
								pid : '',
								last_name : 'TBD',
								playerHeader : playerHeaderDefault,
								number : '',
								arm : '',
								losses : '',
								tbd : true,
								verified : false,
								wins : ''
							},
							radio : (typeof gamecenter.home_radio === 'string' ? gamecenter.home_radio : undefined) || undefined,
							record : linescore.home_win + '-' + linescore.home_loss,
							shortname : linescore.home_name_abbrev,
							vs : linescore.away_name_abbrev
						},
						teams : []
					}
				};

			dataPack.pregame.teams = [dataPack.pregame.away, dataPack.pregame.home];
			dataPack.pregame.teams[0].index = 0;
			dataPack.pregame.teams[1].index = 1;
			dataPack.pregame.game.hasPromos = gamecenter && gamecenter.ticketsLink;
			dataPack.pregame.game.showTickets = isTeamKnown &&
												!isPostponed &&
												linescore.abstractGameState !== GameStates.ABSTRACT_FINAL && 
												linescore.abstractGameState !== GameStates.ABSTRACT_OTHER &&
												// We do not show ticket links for Brooklyn Cyclones home games.. seriously
												linescore.game_pk != 472929 &&
												// linescore.game_pk != 448202 && 
												linescore.home_team_id != 453;

			// dataPack.pregame.game.showStatus = isPostponed || isDelayed;
			if(isPostponed || isDelayed || isCancelled){
				dataPack.pregame.game.showStatus = true;
				dataPack.pregame.game.showDate = false;
				dataPack.pregame.game.displayStatus = (isDelayed && 'Delayed' || isPostponed && "Postponed" || isCancelled && "Cancelled" || "");
				if(dataPack.pregame.game.displayStatus && linescore.status_reason){
					dataPack.pregame.game.displayStatus += (" - " + linescore.status_reason);
				} 
			} else {
				dataPack.pregame.game.showDate = sport_code == 'mlb' ; // Really we want this to only be hidden in milb's app..
				dataPack.pregame.game.showStatus = false;
			}
			dataPack.pregame.game.showBroadcast = !dataPack.pregame.game.showStatus && (dataPack.pregame.home.channels || dataPack.pregame.away.channels);
			if(sport_code !=='mlb'){
				MessageService.publish(UpdateEvents.UPDATE_PREGAME, dataPack);
				return;
			}
			// Each teams lineups vs the opposing pitcher over the last 5 years and batting season stats
			var awayBatters, homeBatters, lineupData, homeBatterStats,awayBatterStats;

			var vsHomeRequest,
				vsAwayRequest,
				awayBattersStatcastRequest,
				homeBattersStatcastRequest,
				lineupRequest;

			if(dataPack.pregame.home.pitcher.pid){
				vsHomeRequest = $.Deferred();
				MessageService.one.call(that, GDC.requestGameData(Datasources.TEAMVSPITCHER5Y, {
					pitcher_id: dataPack.pregame.home.pitcher.pid,
					team_id: linescore.away_team_id,
					game_type: 'R'
				}),function(resp) {
					vsHomeRequest.resolve(resp)
				});
			} else {
				vsHomeRequest = {};
			}
			if(dataPack.pregame.away.pitcher.pid){
				vsAwayRequest = $.Deferred();
				MessageService.one.call(that, GDC.requestGameData(Datasources.TEAMVSPITCHER5Y, {
					pitcher_id: dataPack.pregame.away.pitcher.pid,
					team_id: linescore.home_team_id,
					game_type: 'R'
				}),function(resp) {
					vsAwayRequest.resolve(resp)
				});
			}else {
				vsAwayRequest = {};
			}

			awayBattersStatcastRequest = $.Deferred();
			MessageService.one.call(that, GDC.requestGameData(Datasources.STATCAST_BATTER_AVERAGES, {
				team_id: linescore.away_team_id,
				season: season
			}),function(resp) {
				awayBattersStatcastRequest.resolve(resp)
			});

			homeBattersStatcastRequest = $.Deferred();
			MessageService.one.call(that, GDC.requestGameData(Datasources.STATCAST_BATTER_AVERAGES, {
				team_id: linescore.home_team_id,
				season: season
			}),function(resp) {
				homeBattersStatcastRequest.resolve(resp)
			});

			if(sport_code == 'mlb'){
				lineupRequest = $.Deferred();
                MessageService.one.call(that, GDC.requestGameData(Datasources.LINEUP, {
					gdpath : linescore.gdid
				}),function(resp) {
					lineupRequest.resolve(resp)
				});
            } else {
            	lineupRequest = {};
            }

			$.whenAlways(vsHomeRequest, vsAwayRequest, awayBattersStatcastRequest, homeBattersStatcastRequest, lineupRequest)
				.always(function(awayBatters, homeBatters, awayBattersStatcast, homeBattersStatcast, lineupData) {

                lineupData = lineupData.lineup || {};
                awayBattersStatcast = awayBattersStatcast.statcastBatterAverages && awayBattersStatcast.statcastBatterAverages.players || {};
                homeBattersStatcast = homeBattersStatcast.statcastBatterAverages && homeBattersStatcast.statcastBatterAverages.players || {};

                var homeBattersById = {},
				awayBattersById = {},
				lineupHome = lineupData.home = lineupData.home || {players : new Array(9), empty : true},
				lineupAway = lineupData.away = lineupData.away || {players : new Array(9), empty : true},
				lineupHomeIds = [],
				lineupAwayIds = [],
				lineupHomeStatcast = [],
				lineupAwayStatcast = [];

				if(lineupData.home.players) {
					lineupData.home.players.forEach(function(player) {
						lineupHomeIds.push(player.playerid); 
					});
				}

				if(lineupData.away.players) {
					lineupData.away.players.forEach(function(player) {
						lineupAwayIds.push(player.playerid); 
					});
				}

				for(i in lineupHome.players) {
					lineupHome.players[i].index = +i + 1;
					if(homeBattersStatcast[lineupHome.players[i].playerid]) {
						homeBattersStatcast[lineupHome.players[i].playerid].index = +i + 1;
						homeBattersStatcast[lineupHome.players[i].playerid].name = lineupHome.players[i].first_name + " " + lineupHome.players[i].last_name;
						homeBattersStatcast[lineupHome.players[i].playerid].position = lineupHome.players[i].position;
						homeBattersStatcast[lineupHome.players[i].playerid].playerid = lineupHome.players[i].playerid;
					} else {
						homeBattersStatcast[lineupHome.players[i].playerid] = {};
						homeBattersStatcast[lineupHome.players[i].playerid].index = +i + 1;
						homeBattersStatcast[lineupHome.players[i].playerid].name = lineupHome.players[i].first_name + " " + lineupHome.players[i].last_name;
						homeBattersStatcast[lineupHome.players[i].playerid].position = lineupHome.players[i].position;
						homeBattersStatcast[lineupHome.players[i].playerid].playerid = lineupHome.players[i].playerid;
					}
					lineupHomeStatcast.push(homeBattersStatcast[lineupHome.players[i].playerid]);
				}

				for(i in lineupAway.players) {
					lineupAway.players[i].index = +i + 1;
					if(awayBattersStatcast[lineupAway.players[i].playerid]) {
						awayBattersStatcast[lineupAway.players[i].playerid].index = +i + 1;
						awayBattersStatcast[lineupAway.players[i].playerid].name = lineupAway.players[i].first_name + " " + lineupAway.players[i].last_name;
						awayBattersStatcast[lineupAway.players[i].playerid].position = lineupAway.players[i].position;
						awayBattersStatcast[lineupAway.players[i].playerid].playerid = lineupAway.players[i].playerid;
					} else {
						awayBattersStatcast[lineupAway.players[i].playerid] = {};
						awayBattersStatcast[lineupAway.players[i].playerid].index = +i + 1;
						awayBattersStatcast[lineupAway.players[i].playerid].name = lineupAway.players[i].first_name + " " + lineupAway.players[i].last_name;
						awayBattersStatcast[lineupAway.players[i].playerid].position = lineupAway.players[i].position;
						awayBattersStatcast[lineupAway.players[i].playerid].playerid = lineupAway.players[i].playerid;
					}
					lineupAwayStatcast.push(awayBattersStatcast[lineupAway.players[i].playerid]);
				}


				dataPack.pregame.home.lineup = lineupHome.players;
				dataPack.pregame.away.lineup = lineupAway.players;
				dataPack.pregame.home.lineup_statcast = lineupHomeStatcast;
				dataPack.pregame.away.lineup_statcast = lineupAwayStatcast;
				dataPack.pregame.home.lineupMessage	= lineupHome.empty ? "Lineup coming soon" : "";
				dataPack.pregame.away.lineupMessage	= lineupAway.empty ? "Lineup coming soon" : "";
				dataPack.pregame.hasLineups = !(lineupData.home.empty && lineupData.away.empty)
				if(!dataPack.pregame.hasLineups){
					dataPack.pregame.active=1;
				}

				dataPack.pregame.hasVS =!!((pitcherHomeSeason || pitcherAwaySeason) && (awayBatters.teamVsPitcher5Y && awayBatters.teamVsPitcher5Y.rows || homeBatters.teamVsPitcher5Y && homeBatters.teamVsPitcher5Y.rows));
				if(!dataPack.pregame.hasVS){
					dataPack.pregame.active=0;
				}
				var lineupHomeRequest = {},
					lineupAwayRequest = {};
					
				if(lineupHomeIds.length){
					lineupHomeRequest = $.Deferred();
					MessageService.one.call(that, GDC.requestGameData(Datasources.TEAMLINEUPHITTINGSTATS, {
						team_id : linescore.home_team_id,
                        playerId : lineupHomeIds,
                        game_type   : "'"+game_type+"'"                 
					}),function(payload){
						lineupHomeRequest.resolve(payload);
					});
				}
				if(lineupAwayIds.length){
					lineupAwayRequest = $.Deferred();

					MessageService.one.call(that, GDC.requestGameData(Datasources.TEAMLINEUPHITTINGSTATS, {
							team_id : linescore.away_team_id,
	                        playerId : lineupAwayIds,
	                        game_type   : "'"+game_type+"'"                 
					}),function(payload){
						lineupAwayRequest.resolve(payload);
					})
				}
				$.whenAlways(lineupHomeRequest,lineupAwayRequest).always(function(homeBatterStats,awayBatterStats){
					if (dataPack.pregame.home.lineup 
						&& homeBatterStats.teamLineupHittingStats 
						&& homeBatterStats.teamLineupHittingStats.players) {
						dataPack.pregame.home.lineup.forEach(function(player) {
							$.extend(player, homeBatterStats.teamLineupHittingStats.players[player.playerid]);
						});
					}

					if (dataPack.pregame.away.lineup 
						&& awayBatterStats.teamLineupHittingStats 
						&& awayBatterStats.teamLineupHittingStats.players) {
						dataPack.pregame.away.lineup.forEach(function(player) {
							$.extend(player, awayBatterStats.teamLineupHittingStats.players[player.playerid]);
						});
					}

					if (awayBatters.teamVsPitcher5Y 
						&& awayBatters.teamVsPitcher5Y.rows) {
						dataPack.pregame.home.pitcher.opposite_team_vs_pitcher = awayBatters.teamVsPitcher5Y.rows;
						dataPack.pregame.home.pitcher.opposite_team_vs_pitcher_statcast = [];
					}

					if (homeBatters.teamVsPitcher5Y 
						&& homeBatters.teamVsPitcher5Y.rows) {
						dataPack.pregame.away.pitcher.opposite_team_vs_pitcher = homeBatters.teamVsPitcher5Y.rows;
						dataPack.pregame.away.pitcher.opposite_team_vs_pitcher_statcast = [];
					}

					if((dataPack.pregame.away.pitcher.opposite_team_vs_pitcher && dataPack.pregame.home.pitcher.opposite_team_vs_pitcher) && 
						dataPack.pregame.away.pitcher.opposite_team_vs_pitcher.length !== dataPack.pregame.home.pitcher.opposite_team_vs_pitcher.length) {
						var homeLength = dataPack.pregame.home.pitcher.opposite_team_vs_pitcher.length,
							awayLength = dataPack.pregame.away.pitcher.opposite_team_vs_pitcher.length;

						if(homeLength > awayLength) {
							for (var i = 0; i < homeLength - awayLength; i ++) {
								dataPack.pregame.away.pitcher.opposite_team_vs_pitcher.push({
									name: " ",
									b_batting_avg: " ",
									b_ab: " ",
									b_home_run: " ",
									b_rbi: " "
								});
							}
						} else {
							for (var i = 0; i < awayLength - homeLength; i ++) {
								dataPack.pregame.home.pitcher.opposite_team_vs_pitcher.push({
									name: " ",
									b_batting_avg: " ",
									b_ab: " ",
									b_home_run: " ",
									b_rbi: " "
								});
							}
						}
					}
					MessageService.publish(UpdateEvents.UPDATE_PREGAME, dataPack);
				});
       		});
		});	
	}
	exports.setGameData = function(game, scenes) {
		gameData = game || gameData;

		var liveState = UrlHasher.getHashParams().game_state;

		// If it's pregame, dispatch data. If its not, only dispatch when requested.
		if(liveState == 'Pregame'){
			this.prepareForDispatch();
		}
	};

	exports.prepareForDispatch = function() {
		if(gameData.linescore.game_pk !== GDC.getGameData().linescore.game_pk) {
			// wrong game, wait for further updates
			return;
		}
		MessageService.one.call(this,GDC.requestGameData(Datasources.GAMECENTER),buildSendData);
	};

	exports.handleUpdateRequest = function() {
		gameData = GDC.getGameData();
		this.prepareForDispatch();
	}
	MessageService.on.call(this, UpdateEvents.REQUEST_PREGAME_DATA, exports.handleUpdateRequest);

});
